<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocpt"><a class="xref" href="#/umaHUANG0010#pt01">The Selfish Youngsters</a></p>
<p class="toc"><a class="xref" href="#/umaHUANG0011#ch01">子—What the Son Did . . .</a></p>
<p class="toc1">Pining Yellow</p>
<p class="toc"><a class="xref" href="#/umaHUANG0012#ch02"><span class="ccust1">父</span>—What the Father Wanted . . .</a></p>
<p class="toc1">Chimney</p>
<p class="toc"><a class="xref" href="#/umaHUANG0013#ch03"><span class="ccust1">母</span>—What the Mother Did Not Know . . .</a></p>
<p class="toc1">The Birthday Girls</p>
<p class="tocpt"><a class="xref" href="#/umaHUANG0014#pt02">The Willful Teenagers</a></p>
<p class="toc"><a class="xref" href="#/umaHUANG0015#ch04"><span class="ccust1">子</span>—With Whom the Son Took Liberties . . .</a></p>
<p class="toc1">If You Were My Legend</p>
<p class="toc"><a class="xref" href="#/umaHUANG0016#ch05"><span class="ccust1">妹</span>—What the Younger Daughter Once Aspired To . . .</a></p>
<p class="toc1">The Match</p>
<p class="toc"><a class="xref" href="#/umaHUANG0017#ch06"><span class="ccust1">姊</span>—How the Older Daughter Looks . . .</a></p>
<p class="toc1">The Homely Girl</p>
<p class="toc"><a class="xref" href="#/umaHUANG0018#ch07"><span class="ccust1">父</span>—What the Father Is Worried About . . .</a></p>
<p class="toc1">The Umbrella</p>
<p class="tocpt"><a class="xref" href="#/umaHUANG0019#pt03">The Women in Love</a><a class="page" id="pviii"></a></p>
<p class="toc"><a class="xref" href="#/umaHUANG0020#ch08"><span class="ccust1">姊</span>—What the Older Daughter Has Got . . .</a></p>
<p class="toc1">Dream Lover</p>
<p class="toc"><a class="xref" href="#/umaHUANG0021#ch09"><span class="ccust1">妹</span>—What the Younger Daughter Falls For . . .</a></p>
<p class="toc1">The Gourmet</p>
<p class="toc"><a class="xref" href="#/umaHUANG0022#ch10"><span class="ccust1">母</span>—What the Mother Is Afraid Of . . .</a></p>
<p class="toc1">My Old Faithful</p>
<p class="tocbmf"><a class="xref" href="#/umaHUANG0023#acknow">Acknowledgments</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-HUANG-0008.vue?bab73198